import React from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, ListItemButton, Stack, Typography } from "@mui/material";

interface NavigationCardProps {
  title: string;
  subtitle?: string;
  selected?: boolean;
  onClick: () => void;
}

export const NavigationCard: React.FC<NavigationCardProps> = ({ title, subtitle, selected = false, onClick }) => {
  return (
    <ListItemButton selected={selected} onClick={onClick}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
        <Box>
          <Typography variant="h6" color="text.primary">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <ChevronRightIcon sx={{ color: "text.disabled" }} />
      </Stack>
    </ListItemButton>
  );
};
